<template>
  <div id="Home_recommend">
    <div class="recommend_list2">
      <template  v-for="item in dataList">
        <router-link :to="productUrl(item)" class="item">
          <div class="img">
            <img class="MaterialPic" v-lazy="item.topup_img + '?x-oss-process=image/resize,w_480'" :alt="item.name">
          </div>
          <div class="info">
            <div class="name"><span>{{item.name}}</span></div>
            <div class="price"><span>{{item.price_format}}</span></div>
          </div>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import GTMTrack from "@/api/gtm-track";

export default {
  name: "HomeRecommendMonpay",
  props:{
    dataList:[]
  },
  activated() {
  },
  methods:{
    productUrl(category) {
      if (category.mode === 'pin') {
        return '/card/' + category.code
      }
      if (category.mode === 'directtopup') {
        return '/direct-top-up/' + category.code
      }
      return '/'
    }
  }
}
</script>

<style scoped>

</style>
